module.exports = __webpack_public_path__ + "static/media/Wirecard_Logo.2995bb6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/Wirecard_Logo.png
// module id = 1025
// module chunks = 0